<template>
  <div class="message-card">
    <!-- 卡片头部 -->
    <div class="msg-card-header">
      <span class="card-title">{{ $t('workbench.coreMetrics') }}</span>
    </div>

    <!-- 内容区域 -->
    <div class="msg-card-content">
      <div class="metrics-grid">
        <div
          v-for="(item, index) in metricsData"
          :key="index"
          class="metric-card"
          :class="{ divider: index < metricsData.length - 1 }"
        >
          <div class="metric-icon">
            <img :src="item.image" alt="" width="60px" height="40px" />
          </div>
          <div class="metric-value" :class="item.valueClass">
            {{ item.value
            }}<sub style="font-size: 14px">{{ item.subValue }}</sub>
          </div>
          <div class="metric-label">{{ item.label }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreData',
  data() {
    return {
      metricsData: [
        {
          value: '120',
          label: this.$t('workbench.todayOutput'),
          iconClass: 'icon-production',
          valueClass: '',
          image: require('@/assets/imgs/core/today.png')
        },
        {
          value: '85.',
          label: this.$t('workbench.todayDeliveryRate'),
          subValue: '73%',
          iconClass: 'icon-efficiency',
          valueClass: '',
          image: require('@/assets/imgs/core/jiaofu.png')
        },
        {
          value: '96.',
          label: this.$t('workbench.todayQualityRate'),
          subValue: '73%',
          iconClass: 'icon-quality',
          valueClass: 'text-green',
          image: require('@/assets/imgs/core/hege.png')
        },
        {
          value: '1.',
          label: this.$t('workbench.inventoryStagnation'),
          subValue: '73%',
          iconClass: 'icon-inventory',
          valueClass: 'text-orange',
          image: require('@/assets/imgs/core/kucun.png')
        },
        {
          value: '0.',
          label: this.$t('workbench.equipmentFailureRate'),
          subValue: '35%',
          iconClass: 'icon-equipment',
          valueClass: 'text-red',
          image: require('@/assets/imgs/core/guzhang.png')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.message-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
}

.msg-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  .card-title {
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 14px;
    color: #333333;
  }

  .header-tag {
    font-weight: 300;
    font-size: 12px;
    color: #cccccc;
    line-height: 12px;
  }
}

.msg-card-content {
  width: 100%;
}

.metrics-grid {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.metric-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px 16px;
  position: relative;
  background: #f7f8fc;
  border-radius: 8px;
  height: 88px;
  //   &.divider::after {
  //     content: '';
  //     position: absolute;
  //     right: -8px;
  //     top: 20%;
  //     bottom: 20%;
  //     width: 1px;
  //     background: linear-gradient(to bottom, transparent, #E8EAF6, transparent);
  //   }
}

.metric-icon {
  position: absolute;
  top: -20px;
  right: 30px;
  width: 40px;
  height: 40px;
}

.icon-bg {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: linear-gradient(135deg, #e8eaf6 0%, #c5cae9 100%);
  position: relative;
  overflow: hidden;

  &::before,
  &::after {
    content: '';
    position: absolute;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.8) 0%,
      transparent 50%
    );
  }

  &::before {
    top: 0;
    left: 0;
    right: 0;
    height: 50%;
  }

  &::after {
    bottom: 0;
    right: 0;
    bottom: 0;
    width: 50%;
    transform: rotate(90deg);
    transform-origin: bottom right;
  }
}

.icon-production {
  background: linear-gradient(135deg, #e8eaf6 0%, #c5cae9 100%);
}

.icon-efficiency {
  background: linear-gradient(135deg, #e3f2fd 0%, #90caf9 100%);
}

.icon-quality {
  background: linear-gradient(135deg, #e8f5e9 0%, #a5d6a7 100%);
}

.icon-inventory {
  background: linear-gradient(135deg, #fff3e0 0%, #ffcc80 100%);
}

.icon-equipment {
  background: linear-gradient(135deg, #ffebee 0%, #ffab91 100%);
}

.metric-value {
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 20px;
  color: #333333;
  line-height: 1;
  //   margin-bottom: 4px;
  font-weight: BoldMT;
  font-size: 24px;
  color: #333333;
  letter-spacing: 0;
  line-height: 40px;

  &.text-green {
    color: #73b950;
  }

  &.text-orange {
    color: #f4b13d;
  }

  &.text-red {
    color: #f5222d;
  }
}

.metric-label {
  font-size: 12px;
  color: #999999;
  text-align: center;
}
</style>
